import { PublicAccount } from "@cede/types";
import {
  Box,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";

type AccountIdsFieldProps = {
  type: string;
  property: string;
  value: string[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
  accounts: PublicAccount[];
};

export const AccountIdsField = ({ type, property, value, onChange, accounts }: AccountIdsFieldProps) => {
  return (
    <FormControl sx={{ position: "relative" }}>
      <InputLabel>{property}</InputLabel>
      <Select
        multiple
        value={value || []}
        onChange={onChange}
        input={<OutlinedInput label={property} />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value: string) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
      >
        {accounts.map((account) => (
          <MenuItem key={account.id} value={account.id}>
            {account.accountName} - {account.id}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{type}</FormHelperText>
    </FormControl>
  );
};
